import { forwardRef, type AnchorHTMLAttributes } from 'react'
import { Link } from 'react-router-dom'

/**
 * `UIProvider linkComponent`: lets @vnetwork/datacentral-ui links (`href`) navigate
 * client-side through react-router.
 */
const RouterLink = forwardRef<
    HTMLAnchorElement,
    AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }
>(function RouterLink({ href, ...rest }, ref) {
    return <Link ref={ref} to={href} {...rest} />
})

export default RouterLink
